import { chalkText, drawCursor } from '../../primitives/chalk';

export const chalkTextBlockRenderer = {
  draw({ ctx, params }) {
    const {
      lines,
      layout,
      fontSize,
      fontFamily,
      justify = 'left',
      charCount = 0,
      showCursor = false,
      time = 0,
      highlightProgresses = [],
      highlights = [],
    } = params;

    if (!Array.isArray(lines) || !layout) return;

    let currentCharCount = 0;
    let cursorX = layout.x;
    let cursorY = layout.yStart;

    ctx.save();
    ctx.font = `${fontSize}px ${fontFamily}`;
    if (
      Number.isFinite(layout.areaX) &&
      Number.isFinite(layout.areaY) &&
      Number.isFinite(layout.areaW) &&
      Number.isFinite(layout.areaH)
    ) {
      ctx.beginPath();
      ctx.rect(layout.areaX, layout.areaY, layout.areaW, layout.areaH);
      ctx.clip();
    }

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      const lineCharsToShow = Math.min(Math.max(0, charCount - currentCharCount), line.length);

      if (lineCharsToShow > 0) {
        const textToShow = line.substring(0, lineCharsToShow);
        const y = layout.yStart + i * layout.lineHeight;

        let x = layout.x;
        if (justify === 'center') {
          const fullWidth = ctx.measureText(line).width;
          x = layout.areaX + (layout.areaW - fullWidth) / 2;
        } else if (justify === 'right') {
          const fullWidth = ctx.measureText(line).width;
          x = layout.areaX + layout.areaW - fullWidth;
        }

        chalkText(ctx, textToShow, x, y, fontSize, 0.92, fontFamily);

        if (lineCharsToShow === line.length && i === lines.length - 1) {
          cursorX = x + ctx.measureText(textToShow).width + 2;
          cursorY = y;
        } else if (lineCharsToShow < line.length) {
          cursorX = x + ctx.measureText(textToShow).width + 2;
          cursorY = y;
        }
      }

      currentCharCount += line.length;
    }

    ctx.restore();

    if (showCursor && charCount < (params.totalChars || 0)) {
      const blinkPhase = (time * 2) % 1;
      drawCursor(ctx, cursorX, cursorY, blinkPhase);
    }

    for (let i = 0; i < highlights.length; i++) {
      const hl = highlights[i];
      const progress = highlightProgresses[i] || 0;
      if (progress <= 0 || hl.mode !== 'underline') continue;
      const y = hl.y + 6;
      const width = hl.width * progress;
      ctx.save();
      ctx.strokeStyle = 'rgba(245, 250, 255, 0.9)';
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(hl.x, y);
      ctx.lineTo(hl.x + width, y);
      ctx.stroke();
      ctx.restore();
    }
  },
};
